import React, { memo } from "react";
import createEntityConnect from "../rx/createEntityConnect";
import { useFetchEntities } from "../layout/createEntityLayout";
import { Messages } from "../../components/OutgoingMessagesPage/Messages";
var MessagesComponent = memo(function (props) {
    var _a;
    var loaderOrNull = useFetchEntities(props);
    if (loaderOrNull)
        return loaderOrNull;
    return (React.createElement(React.Fragment, null, (_a = props.heading) !== null && _a !== void 0 ? _a : null,
        React.createElement(Messages, { messages: props.records, defaultCollapsed: true })));
});
export var UserMessagesScreen = createEntityConnect({
    entityName: "messages",
    columnHeaders: [],
})(MessagesComponent);
